import jsPDF from "jspdf";
import "jspdf-autotable";
import { unitSelectorPDF } from './unitSelectorPDF.js';
import { parameterTextConverter } from './parameterTextConverter.js';

const PDFRender = (data, lastUpdated, onError) => {
    try {
        const doc = new jsPDF();
        const tableColumn = ["Estación", "Parámetro", "Fecha", "Estado", "Valor", "Unidad"];
        const tableRows = [];

        for (const station of data) {
            for (const sensor of station.realtime) {
                tableRows.push([
                    station.nombre,
                    parameterTextConverter(sensor.tableRow.parameter),
                    sensor.tableRow.datetime,
                    sensor.tableRow.status,
                    sensor.tableRow.value,
                    unitSelectorPDF(sensor.tableRow.parameter),
                ]);
            }
        }

        doc.autoTable({ head: [tableColumn], body: tableRows, startY: 10, theme: 'grid' });

        const dateStr = (lastUpdated ?? new Date()).toISOString().slice(0, 10);
        doc.save(`report_${dateStr}.pdf`);
    } catch (error) {
        console.error('Error al generar el PDF:', error);
        if (onError) onError();
        else alert('No se pudo generar el PDF. Intenta nuevamente.');
    }
};

export default PDFRender;
